import React, { useState, useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Highcharts3D from "highcharts/highcharts-3d";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBars } from "react-icons/fa";
import html2canvas from "html2canvas";
import Cards from "../components/Cards";
import { Row } from "react-bootstrap";

Highcharts3D(Highcharts);

const dataSets = {
  "Record Count": [
    { name: "AETNA", data: [58.74, 37.05, 0.19, 4.01, null, null] },
    { name: "BCBS", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
    { name: "Cigna", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
    { name: "UHC", data: [null, 99.73, 0.13, 0.15, null, null] },
  ],
  "Billing Code Count": [
    { name: "AETNA", data: [91.34, 86.89, 5.91, 73.43, null, null] },
    { name: "BCBS", data: [76.38, 73.54, 52.58, 76.38, 43.58, 36.75] },
    { name: "Cigna", data: [79.88, 79.88, 3.23, 59.26, 11.16, null] },
    { name: "UHC", data: [null, 98.89, 2.4, 32.22, null, null] },
  ],
  "Provider Count": [
    { name: "AETNA", data: [61.42, 41.89, 2.06, 3.37, null, null] },
    { name: "BCBS", data: [65.0, 44.58, 3.91, 11.84, 2.72, 0.6] },
    { name: "Cigna", data: [96.51, 6.65, 0.25, 14.12, 0.0, null] },
    { name: "UHC", data: [null, 98.57, 2.4, 1.05, null, null] },
  ],
  "TIN Count": [
    { name: "AETNA", data: [74.74, 26.86, 4.21, 3.37, null, null] },
    { name: "BCBS", data: [62.39, 42.68, 6.24, 11.22, 2.6, 1.23] },
    { name: "Cigna", data: [97.24, 5.05, 0.26, 12.55, null, null] },
    { name: "UHC", data: [null, 97.14, 5.08, 1.05, null, null] },
  ],
};
const Percentage2DColor = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [metricDropdownOpen, setMetricDropdownOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isAutoScale, setIsAutoScale] = useState(true); // Auto-scaling state
  const [selectedMetric, setSelectedMetric] = useState("Record Count");
  const chartContainerRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => {
      if (!prev) setMetricDropdownOpen(false); // Close metric dropdown when opening main dropdown
      return !prev;
    });
  };

  const toggleMetricDropdown = () => {
    setMetricDropdownOpen((prev) => {
      if (!prev) setDropdownOpen(false); // Close main dropdown when opening metric dropdown
      return !prev;
    });
  };

  const categories = [
    "Fee Schedule",
    "Negotiated",
    "Percentage",
    "Per Diem",
    "Derived",
    "Bundle",
  ];

  const handleMetricChange = (metric) => setSelectedMetric(metric);
  const [seriesData, setSeriesData] = useState("");

  useEffect(() => {
    setSeriesData(dataSets[selectedMetric]);
  }, [selectedMetric]);

  console.log(seriesData);

  const customColors = ["#CCDAF5", "#C0BBC9", "#A9DBEF", "#CEEDD0"];

  // Function to calculate the maximum y-axis value
  const calculateYAxisMax = (categoryIndex) => {
    if (isAutoScale) {
      if (!seriesData || seriesData.length === 0) {
        return 10;
      }
      const values = seriesData
        .map((series) => series.data[categoryIndex])
        .filter((value) => value !== null && value !== undefined);
      if (values.length === 0) {
        return 10;
      }
      const maxValue = Math.max(...values);
      return maxValue < 10 ? 10 : 100;
    } else {
      return 100;
    }
  };

  const handleFullScreen = () => {
    if (chartContainerRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        chartContainerRef.current.requestFullscreen().catch((err) => {
          console.error("Error attempting fullscreen:", err);
        });
      }
    }
  };

  const captureScreenshot = async () => {
    if (chartContainerRef.current) {
      const canvas = await html2canvas(chartContainerRef.current, {
        useCORS: true,
        scale: 2,
        fontFamily: "'Roboto Flex', serif !important",
      });
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "graph.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullScreenChange);
  }, []);

  const renderIndividualGraphs = () => (
    <div className="row mt-5">
      {categories.map((category, index) => {
        const filteredData =
          seriesData &&
          seriesData.map((series, i) => ({
            name: series.name,
            data: [series.data[index]],
            color: customColors[i],
          }));

        const yAxisMax = calculateYAxisMax(index);

        return (
          <div
            key={category}
            className="col-md-4 mb-2 d-flex align-items-stretch"
          >
            <div
              id={`chart-${category.toLowerCase().replace(" ", "-")}`}
              className="w-100"
            >
              <HighchartsReact
                highcharts={Highcharts}
                options={{
                  chart: {
                    type: "column",
                    height: 270,
                    pointWidth: 20,
                    borderRadius: 10,
                  },
                  exporting: { enabled: false },
                  title: {
                    text: null,
                    style: {
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "16px",
                      color: "#333",
                    },
                  },
                  xAxis: {
                    categories: [category],
                    labels: {
                      style: {
                        fontWeight: "bold",
                      },
                    },
                  },
                  yAxis: {
                    min: 0,
                    max: yAxisMax,
                    labels: {
                      useHTML: true, // Enables custom spacing
                      formatter: function () {
                        return `<span style="display: inline-block; width: 30px; text-align: right;">${this.value
                          .toString()
                          .padStart(3, "\u00A0")}</span>`;
                      },
                      style: {
                        fontSize: "12px",
                      },
                    },
                    title: {
                      text: null,
                      style: {
                        fontFamily: "Montserrat",
                        fontWeight: "normal",
                      },
                    },
                  },
                  series: filteredData,
                  credits: { enabled: false },
                  plotOptions: {
                    series: {
                      states: {
                        hover: {
                          brightness: -0.05, // darken
                        },
                      },

                      dataLabels: {
                        enabled: true,
                        format: "{y}",
                        style: {
                          fontSize: "12px",
                          fontFamily: "'Roboto Flex', serif !important",
                          fontWeight: "normal",
                        },
                      },
                    },
                    column: { depth: 50 },
                  },
                  colors: customColors,
                  // tooltip: {
                  //   backgroundColor: "#333",
                  //   borderRadius: 8,
                  //   style: {
                  //     color: "#fff",
                  //     fontSize: "14px",
                  //     fontFamily: "'Montserrat', sans-serif",
                  //   },
                  // },

                  tooltip: {
                    headerFormat:
                      '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
                      '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span><br>',
                    pointFormat:
                      "<div style='display:flex; flex-direction:row, align-items: center'><div style='margin-right: 0px; width:45px'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
                    shared: true,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    borderColor: "#A9A9A9",
                    borderRadius: 7,
                    animation: false, // Disables animation for instant display
                    hideDelay: 0, // Removes delay when hiding the tooltip
                    style: {
                      color: "#333",
                      fontFamily: "'Roboto Flex', serif",
                      //   transition: "none", // Ensures no transition delay
                      transition: "opacity 0.52s ease-in",
                      fontSize: "12px",
                      padding: "8px",
                      shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
                      zIndex: 99999, // Ensures it stays above everything
                    },
                    shadow: true, // Adds a subtle shadow to improve visibility
                    useHTML: true, // Allows for better positioning control
                    outside: true, // Forces tooltip outside the chart container
                  },

                  legend: { enabled: false },
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );

  const renderLegend = () => (
    <div className="d-flex justify-content-center ">
      {seriesData &&
        seriesData.map((series, index) => (
          <div key={series.name} className="d-flex align-items-center mx-3">
            <div
              style={{
                width: 16,
                height: 16,
                backgroundColor: customColors[index],
                borderRadius: "20%",
                fontFamily: "'Roboto Flex', serif",
                marginRight: 8,
              }}
            />
            <span
              style={{
                fontSize: "12px",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              {series.name}
            </span>
          </div>
        ))}
    </div>
  );

  return (
    <div className="mx-4">
      <div className="container-graphs">
        <Cards />

        <div className="d-flex justify-content-between">
          <div className="dropdown">
            <button
              className="btn border dropdown-toggle"
              type="button"
              onClick={toggleMetricDropdown}
              style={{ backgroundColor: "white" }}
            >
              {selectedMetric}
            </button>
            {metricDropdownOpen && (
              <div className="dropdown-menu show">
                {Object.keys(dataSets).map((metric) => (
                  <button
                    key={metric}
                    className="dropdown-item"
                    onClick={() => {
                      handleMetricChange(metric);
                      setMetricDropdownOpen(false); // Close dropdown after selection
                    }}
                  >
                    {metric}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="position-relative">
            {/* Menu button */}
            <button className="btn border p-2" onClick={toggleDropdown}>
              <FaBars size={20} />
            </button>

            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div
                className="position-absolute bg-white border rounded shadow p-2"
                style={{
                  right: 0,
                  top: "110%",
                  minWidth: "180px",
                  zIndex: 10,
                }}
              >
                <button
                  className="dropdown-item p-2"
                  onClick={captureScreenshot}
                >
                  Download
                </button>
                <button
                  className="dropdown-item p-2"
                  onClick={handleFullScreen}
                >
                  {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
                </button>
                <button
                  className="dropdown-item p-2"
                  onClick={() => setIsAutoScale(!isAutoScale)}
                >
                  {isAutoScale
                    ? "Switch to Manual Scaling"
                    : "Switch to Auto Scaling"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid card mt-4 d-flex flex-column">
        <h5 className="d-flex chart-topic justify-content-center mb-0 pt-3">
          {selectedMetric} of Negotiated Arrangement and Type
        </h5>

        <div
          id="individual-graphs"
          ref={chartContainerRef}
          className={`chart-container ${isFullScreen ? "fullscreen" : ""}`}
          style={{ padding: "20px" }}
        >
          {renderLegend()}
          {renderIndividualGraphs()}
        </div>
      </div>
    </div>
  );
};

export default Percentage2DColor;
